import React from 'react'

import {
  Button, Close, Icon,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func, string } from 'prop-types'

function ModalHeader({ closeModal, title }) {
  return (
    <div className="license-modal__header">
      <h1 className="license-modal__title">{title}</h1>
      <div className="license-modal__close-button-container">
        <Button
          size="small"
          type="ghost"
          variant="only-icon"
          customClass="license-modal__close-button"
          onClick={closeModal}
          icon={<Icon svgComponent={Close} />}
        />
      </div>
    </div>
  )
}

ModalHeader.propTypes = {
  closeModal: func.isRequired,
  title: string.isRequired,
}

export default ModalHeader
